export const SET_PATHNAME = 'SET_PATHNAME';
